<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">{{ $t('Traffic Calculator') }}</div>
        </div>

        <!--                <div class="traff-calc-group-wrap">-->
        <!--                    <dspMultiSelect v-model="selectedGroupFields"-->
        <!--                                    :options="groupFieldsList"-->
        <!--                                    :placeholder="$t('Сountry')"-->
        <!--                                    @input="tableChangeGroup"-->
        <!--                    />-->
        <!--                </div>-->


        <!--                <div class="traff-calc-filter-wrap">-->
        <!--                    <filterDropdown-->
        <!--                        v-model="tableFilter"-->
        <!--                        :items="groupFieldsList"-->
        <!--                        :getValues="tableFilterGetValues"-->
        <!--                        :btnText="$t('Add Filter')" />-->

        <!--                </div>-->
        <div class="traff-calc-btn-wrap">
          <dspButtonGroup class="mr-20 mt-20">
            <dspButton :class="{ active: campaignType==='banner' }" @click="campaignType='banner'">{{ $t('Banner') }}
            </dspButton>
            <dspButton :class="{ active: campaignType==='native' }" @click="campaignType='native'">{{ $t('Native') }}
            </dspButton>
            <dspButton :class="{ active: campaignType==='video' }" @click="campaignType='video'">{{ $t('Video') }}
            </dspButton>
            <!--                        <dspButton-->
            <!--                            :class="{ active: campaignType==='push' }"-->
            <!--                            @click="campaignType='push'">{{ $t('Push') }}-->
            <!--                        </dspButton>-->
            <!--                        <dspButton-->
            <!--                            :class="{ active: campaignType==='pop' }"-->
            <!--                            @click="campaignType='pop'">{{ $t('Pop') }}-->
            <!--                        </dspButton>-->
            <!--                        <dspButton-->
            <!--                            :class="{ active: campaignType==='audio' }"-->
            <!--                            @click="campaignType='audio'">{{ $t('Audio') }}-->
            <!--                        </dspButton>-->
          </dspButtonGroup>


          <dspButtonGroup class="mr-20 mt-20">
            <dspButton v-bind:class="{ active: deviceType==='desktop' }" :isDisabled="videoDesktopDisabled"

                       @click="deviceType='desktop'">{{ $t('Desktop') }}
            </dspButton>
            <dspButton v-bind:class="{ active: deviceType==='mobile' }" @click="deviceType='mobile'">{{ $t('Mobile') }}
            </dspButton>
            <dspButton v-bind:class="{ active: deviceType==='tablet' }" @click="deviceType='tablet'">{{ $t('Tablet') }}
            </dspButton>
          </dspButtonGroup>

        </div>
        <div class="traff-calc-btn-wrap">
          <dspButtonGroup class="mr-20 mt-20">
            <dspButton v-bind:class="{ active: trafficType==='site' }"
                       :isDisabled="trafficVideoMobileSiteDisabled"
                       @click="trafficType='site'">{{ $t('Site') }}
            </dspButton>
            <dspButton v-bind:class="{ active: trafficType==='app' }"
                       :isDisabled="trafficTypeAppDisabled"
                       @click="trafficType='app'">{{ $t('App') }}
            </dspButton>
          </dspButtonGroup>
          <dspButton @click="applyTypes" class="primary mt-20">{{ $t('Apply') }}
          </dspButton>
        </div>
        <!--                                <box class="chart-wrap">-->
        <!--                                    <tableTopActions>-->

        <!--                                    </tableTopActions>-->
        <!--                                    <div v-if="isChartsBusy" class="empty-table">-->
        <!--                                        <img src="../../images/loader_smaller.svg" alt="">-->
        <!--                                    </div>-->
        <!--                                    <highcharts v-else-if="chartDataFull.length>0" ref="chart" :options="chartOptions"></highcharts>-->
        <!--                                    <div v-else class="empty-table">-->
        <!--                                        <h4 class="h4">{{ $t('No data to display') }}</h4>-->
        <!--                                    </div>-->

        <!--                                </box>-->


        <div class="traff-calc-group-wrap" v-if="campaignType==='video'">
          <div class="form-group inner full-width">
            <!--                        <dspCheckbox-->
            <!--                            :isChecked="isRewardedVideo"-->
            <!--                            :inpLabel="this.$t('Rewarded video')"-->
            <!--                            @change="onUpdateIsRewardedVideo($event)"-->
            <!--                            class="pr-4"-->
            <!--                        />-->

            <dspCheckbox v-if="deviceType!=='desktop' &&  this.deviceType !== 'tablet'"
                         :isChecked="isCTVVideo"
                         :inpLabel="$t('CTV')"
                         :isDisabled="CTVDisabled"
                         @change="onUpdateIsCTVVideo($event)"/>
          </div>
        </div>


        <!--                <div class="row">-->
        <!--                    <div class="col-md-12">-->
        <div class="traff-calc-group-wrap">
          <inputGroup class="wide-input-group alt-error budget" prepend="Budget:">
            <dspInput v-model="budgetFix"
                      class="budget"
                      type="number"
                      step="10"
                      v-validate="{ required: true, finance: true, finance_min_value: 5, max_value:  this.chartOptions.xAxis.max }"
                      :data-vv-as="$t('Recommended budget')"
                      :errorsBag="errors"
                      @change="changeBudget($event)"
                      name="bidPrice"
                      ref="bidPriceInput"/>


            <!--                                            <div id="paypal-button" class="paypal-button"></div>-->
          </inputGroup>
        </div>
        <!--                    </div>-->
        <!--                </div>-->


        <div class="traff-calc-filter-wrap">
          <filterDropdown v-model="tableFilter"
                          :items="groupFieldsList"
                          :getValues="tableFilterGetValues"
                          :btnText="$t('Add Filter')"/>
          <!--                    <div-->
          <!--                        :class="{active: showChart}"-->
          <!--                        @click="showChart=!showChart"-->
          <!--                        class="graph-btn"-->
          <!--                    >-->
          <!--                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
          <!--                            <path fill-rule="evenodd" clip-rule="evenodd"-->
          <!--                                  d="M12 9C12.5523 9 13 9.44772 13 10V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V10C11 9.44772 11.4477 9 12 9Z"-->
          <!--                                  fill="#C2CAD8"/>-->
          <!--                            <path fill-rule="evenodd" clip-rule="evenodd"-->
          <!--                                  d="M18 3C18.5523 3 19 3.44772 19 4V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V4C17 3.44772 17.4477 3 18 3Z"-->
          <!--                                  fill="#C2CAD8"/>-->
          <!--                            <path fill-rule="evenodd" clip-rule="evenodd"-->
          <!--                                  d="M6 15C6.55228 15 7 15.4477 7 16V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V16C5 15.4477 5.44772 15 6 15Z"-->
          <!--                                  fill="#C2CAD8"/>-->
          <!--                        </svg>-->

          <!--                    </div>-->
        </div>
        <!--                                <transition name="slide" mode="out-in">-->
        <!--                                    <box v-if="showChart" class="chart-wrap">-->
        <!--                                        <dspButtonGroup class="ml-2 mt-20 mb-5">-->
        <!--                                            <dspButton-->
        <!--                                                v-bind:class="{ active: chartType===1 }"-->
        <!--                                                @click="changeChartType(1)">{{ $t('Bar Chart') }}</dspButton>-->
        <!--                                            <dspButton-->
        <!--                                                v-bind:class="{ active: chartType===2 }"-->
        <!--                                                @click="changeChartType(2)">{{ $t('Pie Chart') }}</dspButton>-->
        <!--                                        </dspButtonGroup>-->
        <!--                                        <div v-if="isChartsBusy" class="empty-table">-->
        <!--                                            <img src="../images/loader_smaller.svg" alt="">-->
        <!--                                        </div>-->
        <!--                                        <highcharts v-else-if="chartOptions.xAxis.categories.length>0" ref="chart" :options="chartOptions"></highcharts>-->
        <!--                                        <div v-else class="empty-table">-->
        <!--                                            <h4 class="h4">{{ $t('No data to display') }}</h4>-->
        <!--                                        </div>-->
        <!--                                    </box>-->
        <!--                                </transition>-->

        <box class="chart-wrap">
          <tableTopActions>

          </tableTopActions>
          <div v-if="isChartsBusy" class="empty-table">
            <img src="../images/loader_smaller.svg" alt="">
          </div>
          <highcharts v-else-if="chartOptions.series[0].data!==[]" ref="chart" :options="chartOptions"></highcharts>
          <div v-else class="empty-table">
            <h4 class="h4">{{ $t('No data to display') }}</h4>
          </div>

        </box>

        <div class="row">
          <!--                    <div class="col-md-3">-->
          <!--                        <div class="traff-calc-group-wrap">-->
          <!--                            <dspMultiSelect v-model="selectedGroupFields"-->
          <!--                                            :options="groupFieldsList"-->
          <!--                                            :placeholder="$t('Сountry')"-->
          <!--                                            @input="tableChangeGroup"-->
          <!--                            />-->

          <!--                        </div>-->
          <!--                    </div>-->
        </div>


        <box class="alt">
          <tableTopActions class="traff-calc-actions reports-top-actions">
            <div class="show-records alt">
              <dspSelect v-model="pagination.perPage" :options="tablePerPageList" :errorsBag="errors"></dspSelect>
              <span>{{ $t('Records per page') }}</span>
            </div>
            <actionOptions :sections="['Performance']"
                           :options="tableNumericFields"
                           :showSelectAll="true"
                           @change="onTableNumericFieldChanged($event)"
                           class="alter"/>
          </tableTopActions>
          <b-table :fields="tableFields"
                   :items="tableDataProvider"
                   :show-empty="true"
                   :sort-by.sync="sortBy"
                   :sort-desc.sync="sortDesc"
                   ref="calcTable"
                   class="traff-calc-table"
                   hover>
            <template slot="empty">
              <div class="empty-table">
                <h4>{{ $t('No data to display') }}</h4>
              </div>
            </template>
            <template slot="table-busy">
              <div class="empty-table">
                <img src="../images/loader_smaller.svg" alt="">
              </div>
            </template>
            <template v-for="(title, field) in sortableFields">
              <template :slot="'HEAD_' + field">
                <sortableColumnHead :title="title" :key="field"/>
              </template>
            </template>
            <template slot="country_dict" slot-scope="row">
              <span>{{ row.item.country_dict }}</span>
              <div v-if="row.item.country_dict"
                   @click="createCampaignWithCountry(row.item.country)"
                   class="company-action"
                   v-b-tooltip.hover.right="$t('Create Campaign')">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.99935 2.00033C4.68564 2.00033 1.99935 4.68662 1.99935 8.00033C1.99935 11.314 4.68564 14.0003 7.99935 14.0003C11.3131 14.0003 13.9993 11.314 13.9993 8.00033C13.9993 4.68662 11.3131 2.00033 7.99935 2.00033ZM0.666016 8.00033C0.666016 3.95024 3.94926 0.666992 7.99935 0.666992C12.0494 0.666992 15.3327 3.95024 15.3327 8.00033C15.3327 12.0504 12.0494 15.3337 7.99935 15.3337C3.94926 15.3337 0.666016 12.0504 0.666016 8.00033Z"
                        fill="#C2CAD8"/>
                  <path id="min"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00065 4.66699C8.36884 4.66699 8.66732 4.96547 8.66732 5.33366V10.667C8.66732 11.0352 8.36884 11.3337 8.00065 11.3337C7.63246 11.3337 7.33398 11.0352 7.33398 10.667V5.33366C7.33398 4.96547 7.63246 4.66699 8.00065 4.66699Z"
                        fill="#C2CAD8"/>
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.66602 7.99967C4.66602 7.63148 4.96449 7.33301 5.33268 7.33301H10.666C11.0342 7.33301 11.3327 7.63148 11.3327 7.99967C11.3327 8.36786 11.0342 8.66634 10.666 8.66634H5.33268C4.96449 8.66634 4.66602 8.36786 4.66602 7.99967Z"
                        fill="#C2CAD8"/>
                </svg>
              </div>
            </template>
            <template slot="region_dict" slot-scope="row">
              <span>{{ row.item.region_dict }}</span>
              <div v-if="row.item.region_dict"
                   @click="createCampaignWithRegion(row.item)"
                   class="company-action"
                   v-b-tooltip.hover.right="$t('Create Campaign')">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.99935 2.00033C4.68564 2.00033 1.99935 4.68662 1.99935 8.00033C1.99935 11.314 4.68564 14.0003 7.99935 14.0003C11.3131 14.0003 13.9993 11.314 13.9993 8.00033C13.9993 4.68662 11.3131 2.00033 7.99935 2.00033ZM0.666016 8.00033C0.666016 3.95024 3.94926 0.666992 7.99935 0.666992C12.0494 0.666992 15.3327 3.95024 15.3327 8.00033C15.3327 12.0504 12.0494 15.3337 7.99935 15.3337C3.94926 15.3337 0.666016 12.0504 0.666016 8.00033Z"
                        fill="#C2CAD8"/>
                  <path id="min"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00065 4.66699C8.36884 4.66699 8.66732 4.96547 8.66732 5.33366V10.667C8.66732 11.0352 8.36884 11.3337 8.00065 11.3337C7.63246 11.3337 7.33398 11.0352 7.33398 10.667V5.33366C7.33398 4.96547 7.63246 4.66699 8.00065 4.66699Z"
                        fill="#C2CAD8"/>
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.66602 7.99967C4.66602 7.63148 4.96449 7.33301 5.33268 7.33301H10.666C11.0342 7.33301 11.3327 7.63148 11.3327 7.99967C11.3327 8.36786 11.0342 8.66634 10.666 8.66634H5.33268C4.96449 8.66634 4.66602 8.36786 4.66602 7.99967Z"
                        fill="#C2CAD8"/>
                </svg>
              </div>
            </template>
            <template slot="city" slot-scope="row">
              <span>{{ row.item.city }}</span>
              <div v-if="row.item.city"
                   @click="createCampaignWithCity(row.item)"
                   class="company-action"
                   v-b-tooltip.hover.right="$t('Create Campaign')">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.99935 2.00033C4.68564 2.00033 1.99935 4.68662 1.99935 8.00033C1.99935 11.314 4.68564 14.0003 7.99935 14.0003C11.3131 14.0003 13.9993 11.314 13.9993 8.00033C13.9993 4.68662 11.3131 2.00033 7.99935 2.00033ZM0.666016 8.00033C0.666016 3.95024 3.94926 0.666992 7.99935 0.666992C12.0494 0.666992 15.3327 3.95024 15.3327 8.00033C15.3327 12.0504 12.0494 15.3337 7.99935 15.3337C3.94926 15.3337 0.666016 12.0504 0.666016 8.00033Z"
                        fill="#C2CAD8"/>
                  <path id="min"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00065 4.66699C8.36884 4.66699 8.66732 4.96547 8.66732 5.33366V10.667C8.66732 11.0352 8.36884 11.3337 8.00065 11.3337C7.63246 11.3337 7.33398 11.0352 7.33398 10.667V5.33366C7.33398 4.96547 7.63246 4.66699 8.00065 4.66699Z"
                        fill="#C2CAD8"/>
                  <path fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.66602 7.99967C4.66602 7.63148 4.96449 7.33301 5.33268 7.33301H10.666C11.0342 7.33301 11.3327 7.63148 11.3327 7.99967C11.3327 8.36786 11.0342 8.66634 10.666 8.66634H5.33268C4.96449 8.66634 4.66602 8.36786 4.66602 7.99967Z"
                        fill="#C2CAD8"/>
                </svg>
              </div>
            </template>
            <template slot="avgBidfloor" slot-scope="row">
              <span v-if="campaignTypeOfData==='push'">$ {{ row.item.avgBidfloor | finance4 }}</span>
              <span v-else>$ {{ row.item.avgBidfloor | finance }}</span>
            </template>
            <template slot="recomendedPrice" slot-scope="row">
              <span v-if="campaignTypeOfData==='banner' && campaignType==='banner' && deviceType==='desktop' && row.item.country==='IND' && trafficType ==='site'">$ {{ 1.5 | finance }}</span>
              <!--                            <span v-else-if="campaignTypeOfData==='banner' && campaignType==='banner' && deviceType==='mobile' && row.item.country==='USA' && trafficType ==='site'" >$ {{ 0.50 | finance }}</span>-->
              <!--                            <span v-else-if="campaignTypeOfData==='banner' && campaignType==='banner' && deviceType==='tablet' && row.item.country==='USA'&&  trafficType ==='site' " >$ {{ 0.53 | finance }}</span>-->
              <!--                          <span v-else-if="campaignTypeOfData==='banner' && campaignType==='banner' && deviceType==='mobile' && row.item.country==='USA' && trafficType ==='app'" >$ {{ 0.75 | finance }}</span>-->
              <!--                          <span v-else-if="campaignTypeOfData==='video' && campaignType==='video' && deviceType==='mobile' && row.item.country==='USA' && trafficType ==='app' && isCTVVideo===false">$ {{ 3.52 | finance }}</span>-->
              <!--                          <span v-else-if="campaignTypeOfData==='video' && campaignType==='video' && deviceType==='mobile' && row.item.country==='USA' && trafficType ==='app' && isCTVVideo===true">$ {{ 12.59 | finance }}</span>-->
              <!--                          <span v-else-if="campaignTypeOfData==='video' && campaignType==='video' && deviceType==='tablet' && row.item.country==='USA' && trafficType ==='site'">$ {{ 2.12 | finance }}</span>-->
              <span v-else>$ {{ row.item.recomendedPrice | finance }}</span>

              <!--                            <span v-if="campaignTypeOfData==='push'">$ {{ row.item.recomendedPrice | finance4 }}</span>-->
              <!--                            <span v-else-if="campaignTypeOfData==='video' && row.item.recomendedPrice > 40">$ 40</span>-->
              <!--                            <span-->
              <!--                                v-else-if="campaignTypeOfData==='native' && row.item.recomendedPrice > 3.5">$ 3.5</span>-->
              <!--                            <span v-else>$ {{ row.item.recomendedPrice | finance }}</span>-->
            </template>
            <template slot="totalRequest" slot-scope="row">
              <span>{{ row.item.totalRequest | integer }}</span>
            </template>
          </b-table>
          <b-pagination v-if="showPagination"
                        v-model="pagination.currentPage"
                        :total-rows="pagination.totalRows"
                        :per-page="pagination.perPage"
                        align="right"
                        aria-controls="data-table"
                        @change="tableChangePage"/>
        </box>
      </div>
    </div>
  </div>
</template>

<script>
import sortableColumnHead from '@/components/shared/sortableColumnHead.vue';

import Highcharts from 'highcharts';

import draggablePoints from 'highcharts/modules/draggable-points';
import { debounce } from 'debounce';
// import moment from "moment";
import { randomArr } from '../lib/randomArrForTrafficCalculator';
import moment from 'moment';

draggablePoints(Highcharts);
export default {
  name: 'TrafficCalculator',

  props: {
    type: {
      type: String,
      default: null
    },
  },

  components: {
    sortableColumnHead,
  },

  data: function () {
    // eslint-disable-next-line no-unused-vars

    return {

      recCpm: 0,
      totalImp: 0,

      chartOptions: {

        title: '',

        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {

                drag: this.dragE,

              }
            },

            // area:{
            //     states: {
            //         hover: {
            //             enabled: false
            //         }
            //     }
            // },

          }
        },
        series: [{
          data: [],
          type: 'line',

          zIndex: 10,
          color: '#740B99',
          marker: {
            enabled: false
          },

          states: {
            inactive: {
              opacity: 1
            },
            hover: {
              enable: false
            }
          },
          enableMouseTracking: false,
          tooltip: {
            // enabled: false,
            followPointer: false,
            followTouchMove: false
          }
        }, {
          data: [],
          type: 'area',
          zIndex: 1,
          color: '#e4ceeb',
          marker: {
            enabled: false
          },
          states: {
            inactive: {
              opacity: 1
            },
            hover: {
              enable: false
            }
          },
          enableMouseTracking: false,
          tooltip: {
            // enabled: false,
            followPointer: false,
            followTouchMove: false
          }
        },],
        tooltip: {
          borderWidth: 1,
          shared: true,
          backgroundColor: '#212B36',
          borderColor: '#212B36',
          className: 'dash-tooltip',
          useHTML: true,
          headerFormat: '<div style=\'display: flex; flex-direction: column;  align-items: center; width: 175px; height: 60px\'>' + '<div style="color:#fff;font-size: 12px; margin-top: 7px; line-height: 20px; display: block; text-align: center; width: 100%"> {point.total} impressions</div><br><div style=\'display: flex; justify-items: center; align-items: center;  width: 100%\'>',
          pointFormat: '<div style=\'margin: 0 auto; color:#fff;font-size:12px; display: flex; align-items: center\'>' + '<b>    {point.xFormater} $</b>' + '</div>',
          footerFormat: '</div></div>',

        },
        xAxis: {
          min: 10,
          max: 1500,
          tickInterval: 100,
          labels: {
            formatter: function () {
              return this.value + ' $';
            }
          }

        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        chart: {
          type: 'spline',
          minPadding: 0,
          maxPadding: 0
        },
      },

      campaignTypeOfData: '',
      tablePerPageList: [10, 25, 50, 100],

      selectedGroupFields: [],
      groupFieldsList: [{
        field: 'country',
        resultField: 'country_dict',
        label: this.$t('Сountry'),
        sortable: true,
        position: 1,
      }, // {
        //     field: 'region',
        //     resultField: 'region_dict',
        //     label: this.$t('Regiоn'),
        //     sortable: true,
        //     position: 2
        // },
        // {
        //     field: 'city',
        //     label: this.$t('Сity'),
        //     sortable: true,
        //     position: 3
        // },
      ],

      tableNumericFields: {
        Performance: [],
      },

      numericFields: [// {data: 'avgBidfloor', name: this.$t('Average Bid Floor')},
        {
          data: 'recomendedPrice',
          name: this.$t('Recommended Price (last 30 days)')
        }, {
          data: 'totalRequest',
          name: this.$t('Bid Requests (last 24 hours)')
        },],

      tableFilter: {
        // country: {
        //     group: {
        //         field: "country",
        //         label: "Сountry",
        //         position: 1,
        //         resultField: "country_dict",
        //         sortable: true
        //     },
        //
        //     values: [
        //         {
        //             checked: true,
        //             label: "France",
        //             value: "FRA",
        //         }
        //     ]
        //
        //
        // }

      },

      pagination: {
        currentPage: 1,
        perPage: 50,
        totalRows: 0,
      },

      sortBy: 'totalRequest',
      sortDesc: true,

      showChart: false,

      chartType: 1,

      isChartsBusy: false,

      budget: 100,

      areaMax: 0,

      randArrCof: randomArr, // chartOptions: {
      //     title: '',
      //     series: [{
      //         data: [],
      //         lineWidth: 2,
      //         tooltip: {
      //             valueDecimals: 0,
      //             valuePrefix: '',
      //             valueSuffix: '',
      //         },
      //         marker: {
      //             symbol: 'circle',
      //             fillColor: '#740B99',
      //             lineWidth: 3,
      //             radius: 6,
      //             lineColor: '#FFFFFF'
      //         }
      //     }],
      //     tooltip: {
      //         borderWidth: 1,
      //         shared: true,
      //         backgroundColor: '#212B36',
      //         borderColor: '#212B36',
      //         className: 'dash-tooltip',
      //         useHTML: true,
      //         headerFormat: "<div style='display: flex; flex-direction: column;  align-items: center; width: 175px; height: 60px'>" +
      //             "<div style=\"color:#fff;font-size: 12px; margin-top: 7px; line-height: 20px; display: block; text-align: center; width: 100%\">{point.key}</div><br><div style='display: flex; justify-items: center; align-items: center;  width: 100%'>",
      //         pointFormat: "<div style='margin: 0 auto; color:#fff;font-size:12px; display: flex; align-items: center'><div style=\"background-color:{point.color}; margin-right: 8px; display:inline-block; width: 16px; height: 16px; border-radius: 3px; line-height: 20px \"></div>" +
      //             "<b>{point.y}</b>" +
      //             "</div>",
      //         footerFormat: '</div></div>',
      //
      //     },
      //     xAxis: {
      //         categories: [],
      //         labels: {
      //             y: 50,
      //             align:'center',
      //             formatter: function () {
      //                 return this.value;
      //             }
      //         },
      //     },
      //     credits: {
      //         enabled: false,
      //     },
      //     legend: {
      //         enabled: false,
      //     },
      //     yAxis: {
      //         title: {
      //             text: ''
      //         }
      //     },
      //     plotOptions: {
      //         pie: {
      //             innerSize: 230,
      //             depth: 45,
      //             dataLabels: {
      //                 enabled: true,
      //                 formatter: function() {
      //                     return this.point.name + ' ' + Math.round(this.percentage*100)/100 + ' %'
      //                     // return Math.round(this.percentage*100)/100 + ' %';
      //                 },
      //             },
      //             showInLegend: true,
      //         },
      //         column: {
      //             borderRadius: 3
      //         },
      //     },
      //     chart: {
      //         type: 'column',
      //         minPadding: 0,
      //         maxPadding: 0
      //     },
      // },
    };
  },

  computed: {
    CTVDisabled () {
      return this.deviceType === 'tablet';
    },
    videoDesktopDisabled () {
      return this.campaignType === 'video';
    },
    trafficTypeAppDisabled () {
      return this.deviceType === 'desktop';
    },

    trafficVideoMobileSiteDisabled () {
      return this.campaignType === 'video' && this.deviceType === 'mobile';
    },

    campaignType: {
      get () {
        return this.$store.getters['trafficCalculator/getCampaignType'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setCampaignType', value);
      }
    },
    budgetFix: {
      get () {
        return this.budget;
      },
      set (value) {
        // console.log( Math.ceil(value / 10) * 10)

        this.budget = Math.ceil(value / 10) * 10;
      }
    },

    isRewardedVideo: {
      get () {
        return this.$store.getters['trafficCalculator/getIsRewardedVideo'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setIsRewardedVideo', value);
      }
    },
    isCTVVideo: {
      get () {
        return this.$store.getters['trafficCalculator/getIsCTVVideo'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setIsCTVVideo', value);
      }
    },

    deviceType: {
      get () {
        return this.$store.getters['trafficCalculator/getDeviceType'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setDeviceType', value);
      }
    },

    trafficType: {
      get () {
        return this.$store.getters['trafficCalculator/getTrafficType'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setTrafficType', value);
      }
    },

    storageTableGroupFieldsSelected: {
      get () {
        return this.$store.getters['trafficCalculator/getTableGroupFieldsSelected'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setTableGroupFieldsSelected', value);
      }
    },

    storageTableNumericFieldsSelected: {
      get () {
        return this.$store.getters['trafficCalculator/getTableNumericFieldsSelected'];
      },
      set (value) {
        this.$store.commit('trafficCalculator/setTableNumericFieldsSelected', value);
      }
    },

    sortableFields () {
      let result = {};
      this.groupFieldsList.filter(item => item.sortable).forEach(item => {
        const field = item.resultField ? item.resultField : item.field;
        result[field] = item.label;
      });

      this.numericFields.forEach(item => {
        const field = item.data;
        result[field] = item.name;
      });

      return result;
    },
    maxBudget () {
      return Math.floor(this.totalImp / this.recCpm / 1000);
    },
    tableFields () {
      let result = this.selectedGroupFields.map(item => ({
        key: item.resultField ? item.resultField : item.field,
        label: item.label,
        sortable: true,
        sortDirection: 'asc',
        class: item.className ? item.className : 'text-left'
      }));

      let numericItemsPerformance = this.tableNumericFields.Performance
          .filter(item => item.checked)
          .map(item => {
            return {
              key: item.data,
              label: item.name,
              sortable: true,
              sortDirection: 'desc',
            };
          });

      let numericItemsMetrics = this.tableNumericFields.Metrics
          .filter(item => item.checked)
          .map(item => {
            return {
              key: item.data,
              label: item.name,
              sortable: true,
              sortDirection: 'desc',
            };
          });

      return result.concat(numericItemsPerformance).concat(numericItemsMetrics);
    },

    showPagination () {
      return this.pagination.totalRows > 0 && this.pagination.perPage > 0 && this.pagination.totalRows / this.pagination.perPage > 1;
    },
  },

  watch: {
    campaignType () {
      this.isCTVVideo = false;
      this.selectedGroupFields = this.selectedGroupFields.filter(filteredItem => this.groupFieldsList.includes(filteredItem));
      if (this.campaignType === 'video' && this.deviceType === 'mobile' && this.trafficType === 'site') {
        this.trafficType = 'app';
      }
      if (this.campaignType === 'video' && this.deviceType === 'desktop') {
        this.deviceType = 'mobile';
      }
    },

    deviceType () {
      this.isCTVVideo = false;

      if (this.deviceType === 'desktop' && this.trafficType === 'app') {
        this.trafficType = 'site';
      }
      if (this.campaignType === 'video' && this.deviceType === 'mobile' && this.trafficType === 'site') {
        this.trafficType = 'app';
      }

    },

    'pagination.perPage' () {
      this.pagination.currentPage = 1;
      this.$refs.calcTable.refresh();
    },

    tableFilter () {
      this.$refs.calcTable.refresh();
      this.getDataChart();
    },
  },

  created () {
    if (this.type) {
      this.campaignType = this.type;
    }
    const field = this.groupFieldsList.find(() => true);
    this.selectedGroupFields.push(field);

    this.setTableActiveGroupFields();
    this.makeTableNumericFields();
    this.getDataChart();
  },

  methods: {
    getDataChart () {
      const numericField = 'totalRequest';

      const filter = this.getFilterStruct();

      let data = {
        // groupBy: [],
        // filter: filter,
        orderField: numericField,
        orderDir: 'desc',
        rowsOnPage: 20,
        page: 1,
      };

      if (this.tableFilter && Object.keys(this.tableFilter).length) {
        for (let groupId in this.tableFilter) {
          let values = this.tableFilter[groupId].values.map(item => item.value);
          if (values.length) {
            filter[groupId] = values;
          }
        }
      }

      data['filter'] = filter;

      this.isChartsBusy = true;
      this.$axios.post('/traffic-calculator', data)
          .then(response => {
            this.isChartsBusy = false;
            this.recCpm = response.data.data[0].recomendedPrice;
            this.totalImp = response.data.data[0].impression;

            let max = Math.floor(this.totalImp / this.recCpm / 1000);

            if (max < 1500) {
              this.chartOptions.xAxis.max = Math.round(max / 10) * 10;

            }

            if (this.chartOptions.xAxis.max < 100) {
              this.budget = Math.round(this.chartOptions.xAxis.max / 2 / 10) * 10;
              this.chartOptions.xAxis.max += 10;
            }
            //     this.chartOptions.xAxis.tickInterval=2;

            // }

            this.drawChart();
          })
          .catch(() => {
            this.isChartsBusy = false;
          });
    },

    drawChart () {
      this.drawMainChart();
      this.drawAreaChart();
      this.drawPointChart();
    },
    drawMainChart () {
      let min = 10;
      let max = 1500;
      let stepX = 10;

      let costOneImp = this.recCpm / 1000;
      let costOneStep = stepX / costOneImp;
      let step = stepX / costOneImp;

      let dataX = [];

      while (min < max) {

        dataX.push([min, Math.floor(step)]);
        step += costOneStep * this.randArrCof[min];
        min += stepX;
      }
      this.chartOptions.series[0].data = dataX;
    },

    drawAreaChart () {

      let stepX = 10;
      let minArea = 10;
      let costOneImp = this.recCpm / 1000;
      let costOneStep = stepX / costOneImp;
      let step = stepX / costOneImp;

      let key = this.budget / 10 - 1;

      let dataArea = [];

      for (let i = 0; i <= key; i++) {
        dataArea.push([minArea, Math.floor(costOneStep)]);
        costOneStep += step * this.randArrCof[minArea];
        minArea += stepX;

        this.areaMax = Math.floor(costOneStep);
      }
      this.chartOptions.series[1].data = dataArea;

    },

    changeBudget: debounce(function (val) {
      if (this.chartOptions.xAxis.max >= parseFloat(val)) {

        // this.budget = parseFloat(val);
        this.drawChart();
      }
    }, 500),

    drawPointChart () {

      this.chartOptions.series[2] = {
        data: [{
          total: this.areaMax,
          xFormater: this.budget,
          name: 'Point 1',
          color: '',
          x: this.budget,
          y: this.areaMax / 2,
          marker: {

            //     fillColor: '#740B99',
            // symbol:'triangle-down'
            symbol: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAt1BMVEUAAABEREBNTUgWFhUHBwcoKCYXFxVERECmpp0GBgYCAgINDQykpJva2s0FBQUCAgELCwrX18rW1soCAgEFBQXT08dDQz9NTUm/v7RTU07R0cTOzsJDQz9hYVsgIB4DAwMGBgYGBgUDAwNgYFsYGBcCAgIBAQEFBQULCwoEBAQCAgEEBAQBAQEBAQECAgEBAQEBAQEMDAsBAQEFBQQYGBZiYlwGBgbX18tMTEgXFxYICAcpKSb////iH/nsAAAAPHRSTlMAAwMKIAYKBAIrmBUCATGrGAEBqjABAwMBAwEBBAIIXiovXwIKd7w1GUWsNubSr8C4Frk2CgIpAQMKIAYVCZWpAAAAAWJLR0Q8p2phzwAAAAlwSFlzAAAO8wAADvMBHFOZOgAAAAd0SU1FB+YFGRcyHX4nSAcAAACUSURBVAjXY2AEAiZmFlYWNiYQk4GRnZ2dg5OLm4uTB8hiB/N5+fgF+PkEgSyIvBCfsICwiCiYLyYuISkF5ktLSojLMMjKySswKAL5igwKSnLKDCqqauoamloCWpoa6mqqKgzaOrpaevoGhkb6elq6OsYMJmjypnJKZsj60c1Htx/hPnM4H9X9jIwWllbWLJYWjEA2AMySEgJFHXwkAAAAE3RFWHRBdXRob3IAUERGIFRvb2xzIEFHG893MAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wNS0yNVQyMzo1MDowOSswMDowMApILusAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDUtMjVUMjM6NTA6MDkrMDA6MDB7FZZXAAAAJHRFWHREZXNjcmlwdGlvbgBodHRwOi8vd3d3LnBkZi10b29scy5jb21fEmayAAAAEXRFWHRUaXRsZQBQREYgQ3JlYXRvckFevCgAAAAASUVORK5CYII=)',
          }
        }],
        dragDrop: {
          draggableX: true,
          dragPrecisionX: 10,
        },

        zIndex: 2,
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            enable: false
          }
        },
        totalImp: this.areaMax,
        enableMouseTracking: true,
        tooltip: {
          total: this.areaMax,
        },

      };
    },

    dragE (e) {

      let newPoint = e.newPoint.x.toFixed(2);

      if (this.budget != newPoint) {
        this.budget = newPoint;
        this.drawMainChart();
        this.drawAreaChart();
        this.drawPointChart();
      }

    },

    applyTypes () {
      if (this.campaignType !== 'video') {
        this.isRewardedVideo = false;
        this.isCTVVideo = false;
      }
      // if (this.campaignType === 'video') {
      //     this.budget = 100;
      //     this.chartOptions.xAxis.min = 10
      //     this.chartOptions.xAxis.max = 50
      //     this.chartOptions.xAxis.tickInterval = 1
      // } else if (this.campaignType === 'audio') {
      //     this.budget = 100;
      //     this.chartOptions.xAxis.min = 5
      //     this.chartOptions.xAxis.max = 50
      //     this.chartOptions.xAxis.tickInterval = 1
      // } else {
      //     this.budget = 100;
      //     this.chartOptions.xAxis.min = 0.5
      //     this.chartOptions.xAxis.max = 10
      //     this.chartOptions.xAxis.tickInterval = 0.5
      // }
      this.getDataChart();
      this.$refs.calcTable.refresh();
      // this.getChart();
    },

    onUpdateIsCTVVideo (value) {
      this.isCTVVideo = value;

      if (this.isCTVVideo) {
        this.isRewardedVideo = false;
      }
    },

    onUpdateIsRewardedVideo (value) {
      this.isRewardedVideo = value;

      if (this.isRewardedVideo) {
        this.isCTVVideo = false;
      }
    },

    tableDataProvider (ctx) {
      let groupBy = this.selectedGroupFields.map(item => item.field);
      let orderField = ctx.sortBy.replace('_dict', '');
      let orderDir = ctx.sortDesc ? 'desc' : 'asc';
      let perPage = this.pagination.perPage ? this.pagination.perPage : 10;
      let page = this.pagination.currentPage ? this.pagination.currentPage : 1;

      let data = {
        groupBy: groupBy,
        rowsOnPage: perPage,
        page: page,
      };

      if (orderField) {
        data['orderField'] = orderField;
        data['orderDir'] = orderDir;
      }

      let filter = this.getFilterStruct();

      if (this.tableFilter && Object.keys(this.tableFilter).length) {
        for (let groupId in this.tableFilter) {
          let values = this.tableFilter[groupId].values.map(item => item.value);
          if (values.length) {
            filter[groupId] = values;
          }
        }
      }

      data['from'] = moment().format('YYYY-MM-DD');
      data['to'] = moment().format('YYYY-MM-DD');
      // console.log(moment().format('YYYY-MM-DD'));
      data['filter'] = filter;

      return this.$axios.post('/traffic-calculator', data)
          .then(response => {
            this.campaignTypeOfData = this.campaignType;
          if (this.pagination.currentPage !== response.data.pagination.page) {
    this.pagination.currentPage = response.data.pagination.page;
  }
            this.pagination.totalRows = response.data.pagination.total;

            this.$nextTick(() => {
            if (this.pagination.currentPage !== response.data.pagination.page) {
    this.pagination.currentPage = response.data.pagination.page;
  }
            });

            return response.data.data;
          })
          .catch(() => {
            this.pagination.currentPage = 1;
            this.pagination.totalRows = 0;

            return [];
          });
    },

    getFilterStruct () {
      let trafficType = this.campaignType;
      if (trafficType === 'push') {
        trafficType = {
          'relation': 'in',
          'values': ['xmlPush', 'pop']
        };
      }

      if (trafficType === 'video' && this.isRewardedVideo) {
        trafficType = 'video_rewarded';
      }

      if (trafficType === 'video' && this.deviceType !== 'desktop' && this.isCTVVideo) {
        trafficType = 'video_ctv';
      }

      let deviceType;

      if (this.deviceType === 'desktop') {
        deviceType = this.trafficType === 'app' ? 'desktopApp' : 'desktopWeb';
      }
      if (this.deviceType === 'mobile') {
        deviceType = this.trafficType === 'app' ? 'mobileApp' : 'mobileWeb';
      }
      if (this.deviceType === 'tablet') {
        deviceType = this.trafficType === 'app' ? 'tabletApp' : 'tabletWeb';
      }

      let deviceTypeDict = {
        'unknown': 0,
        'desktopApp': 1,
        'desktopWeb': 2,
        'tabletApp': 3,
        'tabletWeb': 4,
        'mobileApp': 5,
        'mobileWeb': 6,
      };
      let formatDict = {
        'unknown': 0,
        'banner': 1,
        'video': 2,
        'native': 3,
        'audio': 4,
      };

      // Build filter payload using new keys. For special legacy cases (push/XML or video subtypes),
      // keep sending trafficType to let backend normalization handle it.
      const payload = {
        deviceType: deviceTypeDict[deviceType],
        isApp: this.trafficType === 'app',
      };

      const isObjectFilter = typeof trafficType === 'object' && trafficType !== null;
      const isSpecialSubtype = typeof trafficType === 'string' && (
        trafficType.startsWith('video_') || trafficType === 'xmlPush' || trafficType === 'pop'
      );

      if (isObjectFilter || isSpecialSubtype) {
        payload.trafficType = trafficType;
      } else {
        payload.format = formatDict[trafficType];
      }

      return payload;
    },

    onTableNumericFieldChanged () {
      this.tableNumericFields.Performance = this.tableNumericFields.Performance.map(item => item);
      this.tableNumericFields.Metrics = this.tableNumericFields.Metrics.map(item => item);

      this.storageTableNumericFieldsSelected = this.tableNumericFields.Performance
          .filter(item => item.checked)
          .map(item => item.data)
          .concat(this.tableNumericFields.Metrics.filter(item => item.checked).map(item => item.data));
    },

    makeTableNumericFields () {
      let performance = [];
      let metrics = [];

      this.numericFields.map(item => {
        let newItem = Object.assign({
          checkID: item.data,
          checked: this.storageTableNumericFieldsSelected.findIndex(selected => selected === item.data) >= 0,
          disabled: false,
        }, item);
        newItem.isMetrics = undefined;

        if (item.isMetrics) {
          metrics.push(newItem);
        } else {
          performance.push(newItem);
        }
      });

      this.tableNumericFields.Performance = performance;
      this.tableNumericFields.Metrics = metrics;
    },

    setTableActiveGroupFields () {
      this.selectedGroupFields = this.groupFieldsList.filter(item => this.storageTableGroupFieldsSelected.findIndex(field => field === item.field) >= 0);
    },

    tableChangePage () {
      this.$refs.calcTable.refresh();
    },

    tableChangeGroup (value) {
      this.selectedGroupFields = value.sort((item1, item2) => {
        if (item1.position < item2.position) {
          return -1;
        }

        if (item1.position > item2.position) {
          return 1;
        }

        return 0;
      });

      if (this.selectedGroupFields.length === 0) {
        this.selectedGroupFields = [this.groupFieldsList.find(() => true)];
        this.$notify.info('Min 1 fields at once');
      }

      if (this.selectedGroupFields.length > 4) {
        this.selectedGroupFields.pop();
        this.$notify.info('Max 4 fields at once');
      }

      this.storageTableGroupFieldsSelected = this.selectedGroupFields.map(item => item.field);

      this.$refs.calcTable.refresh();
    },

    tableFilterGetValues (group) {
      const filter = this.getFilterStruct();

      return this.$axios.post('/traffic-calculator', {
        groupBy: [group.field],
        filter: filter,
        orderField: group.field !== 'city' ? group.field + '_dict' : group.field,
        orderDir: 'asc',
        rowsOnPage: 500,
        page: 1,
      })
          .then(response => {

            let data = response.data.data;

            let newData = data.filter(function (el) {
              return el[group.field] !== '';
            });

            return newData.map(item => {
              const label = item[group.resultField ? group.resultField : group.field];
              const value = item[group.field];
              let checked = false;

              if (this.tableFilter[group.field] && this.tableFilter[group.field].values.findIndex(item => item.value === value) >= 0) {
                checked = true;
              }

              return {
                label: label,
                value: value,
                checked: checked,
              };
            });

          })
          .catch(() => {
            return [];
          });
    },

    async getCityByName (countryISO3, regionISO2, cityName) {
      const params = new URLSearchParams();
      params.append('search', 'country_iso3:' + countryISO3 + ';state_iso2:' + regionISO2 + ';city_name:' + cityName);
      params.append('searchFields', 'country_iso3:in;state_iso2:in;city_name:like');
      params.append('searchJoin', 'and');
      params.append('selectedCountries', countryISO3);
      params.append('selectedRegions', regionISO2);

      let result = await this.$axios.get('/geo/cities', { params: params });
      if (result.status !== 200 || !result.data.data.length) {
        return null;
      }

      return result.data.data[0].geoname_id;
    },

    getCampaignCreatingParams (addingData) {
      let data = {
        type: this.campaignType,
        isDesktopWeb: false,
        isMobileApp: false,
        isMobileWeb: false,
        isSmartphone: false,
        isTablet: false,
        isCTV: false,
        isRewarded: false,
      };

      if (this.deviceType === 'desktop' && this.trafficType !== 'app') {
        data['isDesktopWeb'] = true;
      }

      if (this.deviceType === 'mobile') {
        data['isSmartphone'] = true;

        if (this.trafficType === 'app') {
          data['isMobileApp'] = true;
        } else {
          data['isMobileWeb'] = true;
        }
      }

      if (this.deviceType === 'tablet') {
        data['isTablet'] = true;

        if (this.trafficType === 'app') {
          data['isMobileApp'] = true;
        } else {
          data['isMobileWeb'] = true;
        }
      }

      if (this.campaignType === 'video' && this.isRewardedVideo) {
        data['isRewarded'] = true;
      }

      if (this.campaignType === 'video' && this.deviceType !== 'desktop' && this.isCTVVideo) {
        data['isCTV'] = true;
      }

      return Object.assign(data, addingData);
    },

    async createCampaignWithCountry (countryISO3) {
      if (!countryISO3) {
        this.$notify.error(this.$t('Unknown country!'));
        return;
      }

      const query = this.getCampaignCreatingParams({
        geoCountries: [countryISO3]
      });

      let routeData = this.$router.resolve({
        name: 'campaigns.edit.settings',
        params: { id: 'create' },
        query,
      });

      window.open(routeData.href, '_blank');
    },

    async createCampaignWithRegion (item) {
      if (!item.country) {
        this.$notify.error(this.$t('Unknown country!'));
        return;
      }

      if (item.region === undefined) {
        this.$notify.error(this.$t('Unknown region! (need select in Group By - Region)'));
        return;
      }
      if (item.region === '') {
        this.$notify.error(this.$t('Unknown region!'));
        return;
      }

      let geoRegions = [item.region];
      if (item.region_dict === item.region) { // If region_dict === region then is not maxmind region code
        geoRegions = [];
      }

      const query = this.getCampaignCreatingParams({
        geoCountries: [item.country],
        geoRegions,
      });

      let routeData = this.$router.resolve({
        name: 'campaigns.edit.settings',
        params: { id: 'create' },
        query,
      });

      window.open(routeData.href, '_blank');
    },

    async createCampaignWithCity (item) {

      if (!item.country) {
        this.$notify.error(this.$t('Unknown country!'));
        return;
      }

      if (item.region === undefined) {
        this.$notify.error(this.$t('Unknown region! (need select in Group By - Region)'));
        return;
      }
      if (item.region === '') {
        this.$notify.error(this.$t('Unknown region!'));
        return;
      }

      let geoRegions = [item.region];
      if (item.region_dict === item.region) { // If region_dict === region then is not maxmind region code
        geoRegions = [];
      }

      const cityId = await this.getCityByName(item.country, item.region, item.city);

      const query = this.getCampaignCreatingParams({
        geoCountries: [item.country],
        geoRegions,
        geoCities: cityId ? [cityId] : [],
      });

      let routeData = this.$router.resolve({
        name: 'campaigns.edit.settings',
        params: { id: 'create' },
        query,
      });

      window.open(routeData.href, '_blank');
    },

    // getChart() {
    //     this.chartOptions.series[0].data = [];
    //     this.chartOptions.xAxis.categories = [];
    //
    //     let groupField = 'country';
    //     const numericField = 'totalRequest';
    //
    //     const filter = this.getFilterStruct();
    //
    //     let data = {
    //         groupBy: [groupField],
    //         filter: filter,
    //         orderField: numericField,
    //         orderDir: 'desc',
    //         rowsOnPage: 20,
    //         page: 1,
    //     };
    //
    //     this.isChartsBusy = true;
    //     this.$axios.post('/traffic-calculator', data)
    //         .then(response => {
    //             this.isChartsBusy = false;
    //             this.chartOptions.chart.type = 'column';
    //             if (this.chartType === 2) {
    //                 this.chartOptions.chart.type = 'pie';
    //             }
    //
    //             let data = [];
    //             const dataCount = response.data.data.length;
    //
    //             let filterCountries = [];
    //             for (let key in this.tableFilter) {
    //                 if (key === 'country') {
    //                     filterCountries = this.tableFilter[key].values.map(item => item.value);
    //                 }
    //             }
    //
    //             this.chartOptions.xAxis.categories = response.data.data
    //                 .sort((item1, item2) => {
    //                     if (filterCountries.includes(item1[groupField])
    //                             && !filterCountries.includes(item2[groupField]))
    //                     {
    //                         return -1;
    //                     }
    //
    //                     if (!filterCountries.includes(item1[groupField])
    //                             && filterCountries.includes(item2[groupField]))
    //                     {
    //                         return 1;
    //                     }
    //
    //                     if (item1[groupField + '_dict'] < item2[groupField + '_dict']) {
    //                         return -1;
    //                     }
    //
    //                     if (item1[groupField + '_dict'] > item2[groupField + '_dict']) {
    //                         return 1;
    //                     }
    //
    //                     return 0;
    //                 })
    //                 .map((item, index) => {
    //                     const name = item[groupField + '_dict'];
    //                     const value = item[numericField];
    //
    //                     let color = '#740B99';
    //                     if (this.chartType === 2) {
    //                         if (dataCount % 2 !== 0 && dataCount-1 === index) {
    //                             color = '#47C0BF';
    //                         } else {
    //                             color = index % 2 === 0 ? '#740B99' : '#FAC713';
    //                         }
    //                     }
    //
    //                     let className = '';
    //                     if (filterCountries.includes(item[groupField])) {
    //                         className ='filter-selected';
    //                     }
    //
    //                     data.push({
    //                         name: name,
    //                         y: Number.parseInt(value),
    //                         color,
    //                         className,
    //                     });
    //
    //                     return item[groupField + '_dict'];
    //                 });
    //
    //             this.chartOptions.series[0].data = data;
    //         })
    //         .catch(() => {
    //             this.isChartsBusy = false;
    //         });
    // },

    changeChartType (type) {
      this.chartType = type;

      // this.getChart();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .filter-selected {
  stroke: #dab0dd;
  stroke-width: 4;
}

.table ::v-deep {
  td.transaction-download {
    padding-left: 37px;
  }

  .link-name {
    a {
      color: #212B36;
    }

    a:hover {
      color: #740B99;
    }
  }

  td {
    .completed {
      color: #740B99;
    }
  }
}

.traff-calc-btn-wrap {
  .button.primary {
    vertical-align: middle;
  }
}

.traff-calc-group-wrap {
  padding-top: 20px;

  .input-wrap {
    display: inline-block;
    min-width: 175px;
  }

  .plus {
    cursor: pointer;
    display: inline-block;
    vertical-align: baseline;

    img {
      display: inline-block;
      vertical-align: middle;
      margin-right: 7px;
    }

    span {
      font-size: 12px;
      line-height: 20px;
      color: #212B36;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.traff-calc-filter-wrap {
  padding-top: 20px;
  padding-right: 45px;
  position: relative;

  .graph-btn {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    right: 21px;
    margin-top: -18px;
    background: linear-gradient(180deg, #FFFFFF 0%, #F9FAFB 100%);
    border: 1px solid #C4CDD5;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 400ms;

    &:hover {
      border: 1px solid #918299;

      svg {
        path {
          fill: #918299;
        }
      }
    }

    &.active {
      border: 1px solid #740B99;

      svg {
        path {
          fill: #740B99;
        }
      }
    }

    svg {
      vertical-align: middle;

      path {
        transition: all 400ms;
      }
    }
  }
}

.modal {
  .text-count {
    background: #FFFFFF;
    border: 1px solid #C4CDD5;
    box-shadow: inset 0px 1px 2px rgba(102, 113, 123, 0.21);
    border-radius: 5px;
    font-weight: normal;
    font-size: 10px;
    line-height: 19px;
    color: #C2CAD8;
    text-align: center;
  }
}

.alert {
  margin-top: 3px;
  padding: 0.25rem 1.25rem;
}

.traff-calc-actions.table-top-actions {
  padding-right: 50px !important;
  padding-top: 10px;
  padding-bottom: 10px;

  & > .options {
    border-left: none;
  }

  .show-records {
    position: static;
  }

  .show-records {
    &.alt {
      span {
        padding-left: 10px;
        font-weight: 600;
        font-size: 12px;
      }
    }
  }
}

.budget {
  flex: 0 0 70px;
}

</style>
